<template>
  <section class="section height-100">
    <div class="tile is-ancestor full-width is-vertical height-100">
      <div class="tile is-parent is-horizontal">
        <dashboard-banner-tile
          :title="$t('Solicitudes')"
          :subtitle="
            $t('Aprovecha al maximo la tecnologia que te permite Myneo 40')
          "
          :ctaText="$t('Acceder')"
          ctaTarget="admin.onBoard.list"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2020-10-12-solicitudes.jpg"
        ></dashboard-banner-tile>

        <dashboard-banner-tile
          :title="$t('Estación de trabajo Ejecutivos')"
          :subtitle="$t('Gestiona tu trabajo: Agenda, Meet, Eventos, Nube ...')"
          :ctaText="$t('Acceder')"
          ctaTarget="https://cloud.myneofintech.com"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-04-23-virtual_office.jpeg"
        ></dashboard-banner-tile>
      </div>

      <div class="tile is-parent">
        <dashboard-banner-tile
          :title="$t('Mi Red')"
          :ctaText="$t('Acceder')"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-12356.jpg"
          ctaTarget="admin.users.list"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Negocios')"
          :ctaText="$t('Acceder')"
          ctaTarget="admin.business"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-vista-trasera-hombre-negocios-hablar-telefono-ciudad.jpg"
        ></dashboard-banner-tile>

        <dashboard-banner-tile
          :title="$t('Finanzas Ejecutivo: Contabilidad')"
          :subtitle="$t('')"
          :ctaText="$t('Acceder')"
          ctaTarget="admin.accounting"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-empresarios-que-trabajan-finanzas-contabilidad-analizan-presupuesto-grafico-financiero-planificacion-futuro-sala-oficina.jpg"
        ></dashboard-banner-tile>
      </div>

      <div class="tile is-parent">
        <dashboard-banner-tile
          :title="$t('Particulares')"
          :ctaText="$t('Acceder')"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-gente-diversa-feliz-divirtiendose-juntos.jpg"
          ctaTarget="admin.private_users"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Community')"
          :ctaText="$t('Acceder')"
          ctaTarget="admin.community"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-concepto-red-abstracto-arreglo-naturaleza-muerta.jpg"
        ></dashboard-banner-tile>

        <dashboard-banner-tile
          :title="$t('Partners')"
          :subtitle="$t('')"
          :ctaText="$t('Acceder')"
          ctaTarget="admin.partners"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-grupo-empresarios-confiados-office.jpg"
        ></dashboard-banner-tile>
      </div>

      <div class="tile is-parent">
        <dashboard-banner-tile
          :title="$t('Ecobanka TV')"
          :ctaText="$t('Acceder')"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-fondo-superposicion-grafica-conexion-red-pantalla-computadora.jpg"
          ctaTarget="https://www.bloomberg.com/live/europe"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Email Corporativo')"
          :ctaText="$t('Acceder')"
          ctaTarget="https://mail.swiss.ecobanka.com/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-mensaje-chat-linea-concepto-texto-social.jpg"
        ></dashboard-banner-tile>

        <dashboard-banner-tile
          :title="$t('Reunion')"
          :subtitle="
            $t(
              'Solicita una reunion con la app que mas se adapte a tu dispositivo'
            )
          "
          :ctaText="$t('Acceder')"
          ctaTarget="https://cloud.myneofintech.com/apps/calendar/dayGrid/Month/now/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2020-10-12-reunion.jpg"
        >
          <div
            class="level"
            style="background: var(--rosa-eco);padding: 15px; border-radius: 10px; margin-top: 10px;"
          >
            <div class="level-item">
              <img
                src="~@/assets/icons/telegram_logo_36.png"
                alt=""
                height="20"
                width="36"
              />
              <h4 class="title is-5 has-text-white">Telegram</h4>
            </div>
            <div class="level-item">
              <img
                src="~@/assets/icons/whatsapp_logo_36.png"
                alt=""
                height="20"
                width="36"
              />
              <h4 class="title is-5 has-text-white">Whatsapp</h4>
            </div>
            <div class="level-item">
              <img
                src="~@/assets/icons/google_meet_48.png"
                alt=""
                height="20"
                width="36"
              />
              <h4 class="title is-5 has-text-white">Meet</h4>
            </div>
          </div>
        </dashboard-banner-tile>
      </div>
    </div>
  </section>
</template>

<script>
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'
export default {
  name: 'Dashboard',
  components: { DashboardBannerTile },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Dashboard'],
      title: 'Dashboard'
    })
  }
}
</script>

<style scoped>
.bg-blur {
  background: #ffffff99;
  border-radius: 10px;
  backdrop-filter: blur(5px) brightness(1.2);
}
.tile.is-child {
  background-size: cover !important;
}
.height-100 {
  height: 100%;
}
</style>
